import { useRef, useState } from 'react';
import { toast } from 'sonner';
import { Camera, X } from 'lucide-react';
import { api } from '../lib/api';
import { imgSrc } from '../lib/cart';

export function PhotoUploader({ images, onChange, max = 5 }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, max - images.length);
    if (!files.length) return;
    setBusy(true);
    try {
      const urls = [];
      for (const f of files) {
        const fd = new FormData(); fd.append('file', f);
        const { data } = await api.post('/uploads/product-photo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        urls.push(data.url);
      }
      onChange([...images, ...urls]);
    } catch (err) { toast.error(err?.response?.data?.detail || 'Échec de l\'envoi'); }
    finally { setBusy(false); if (ref.current) ref.current.value = ''; }
  };
  return (
    <div className="md:col-span-2" data-testid="photo-uploader">
      <div className="flex flex-wrap gap-2">
        {images.map((u, i) => (
          <div key={u} className="relative h-20 w-20 rounded-xl overflow-hidden border border-slate-700">
            <img src={imgSrc(u)} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => onChange(images.filter((x) => x !== u))} data-testid={`photo-remove-${i}`} className="absolute top-0.5 right-0.5 h-5 w-5 grid place-items-center rounded-full bg-black/70 text-white"><X className="h-3 w-3" /></button>
          </div>
        ))}
        {images.length < max && (
          <label data-testid="photo-add" className="h-20 w-20 rounded-xl border-2 border-dashed border-slate-600 grid place-items-center text-slate-400 cursor-pointer hover:border-sky-400 text-[10px] text-center">
            <div><Camera className="h-5 w-5 mx-auto" />{busy ? 'Envoi…' : `Photo ${images.length + 1}/${max}`}<div className="text-[9px] text-slate-500">Galerie ou appareil</div></div>
            <input ref={ref} type="file" accept="image/*,.heic,.heif" multiple className="hidden" onChange={upload} disabled={busy} />
          </label>
        )}
      </div>
    </div>
  );
}
